import React, { Fragment, useState } from "react";
import { Container, Row } from "reactstrap";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import AgeingReportHistoryProvisionSection from "./ageingReportHistoryProvisionSection";
import AgeingReportHistoryOverdueSection from "./ageingReportHistoryOverdueSection";

const AgeingReportHistorySection = (props) => {
  const [activeMainTab, setActiveMainTab] = useState("od");
  const handleMainTabChange = (event, newValue) => {
    setActiveMainTab(newValue);
  };
  return (
    <Fragment>
      <Container fluid={true}>
        <Row>
          <TabContext value={activeMainTab}>
            <TabList
              onChange={handleMainTabChange}
              aria-label="lab API tabs example"
              indicatorColor="secondary"
              textColor="secondary"
              style={{ background: "white" }}
            >
              <Tab label="OD History " value="od" />
              <Tab label="Provision History" value="prov" />
            </TabList>
            <TabPanel value="od">
              <AgeingReportHistoryOverdueSection {...props} />
            </TabPanel>
            <TabPanel value="prov">
              <AgeingReportHistoryProvisionSection {...props} />
            </TabPanel>
          </TabContext>
        </Row>
      </Container>
    </Fragment>
  );
};

export default AgeingReportHistorySection;
